import type { FC } from 'react'
import { cx } from 'src/utils/cx'
import FluentSpinnerIos20Filled from '~icons/fluent/spinner-ios-20-filled'
import BenefitCardIcon from '../assets/benefit-card-icon.svg?react'

export const KaisuukenBadge: FC<{
  totalMatching: number
  isChecking: boolean
  color?: string
  bgColor?: string
  size?: 'sm' | 'md'
}> = ({ totalMatching, isChecking, color, bgColor, size = 'sm' }) => {
  if (totalMatching === 0) return null
  const iconSize = size === 'sm' ? 'size-4' : 'size-5'
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm'
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1 rounded-full font-semibold',
        textSize,
      )}
      style={{ color, backgroundColor: bgColor }}
    >
      <BenefitCardIcon className={iconSize} />
      {isChecking ? (
        <FluentSpinnerIos20Filled className={cx(iconSize, 'animate-spin')} />
      ) : (
        <span>{totalMatching}</span>
      )}
    </span>
  )
}
